const SET_OPTIMIZELY_IS_AVAILABLE = 'SET_OPTIMIZELY_IS_AVAILABLE';

export const setAvailable = () => ({ type: SET_OPTIMIZELY_IS_AVAILABLE });

const INITIAL_STATE = {
  isLoaded: false,
  isAvailable: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_OPTIMIZELY_IS_AVAILABLE:
      return {
        ...state,
        isAvailable: true,
      };
    default:
      return state;
  }
};
